import React from 'react';

const Phone: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" fill="none" {...props}>
    <path
      fill="currentColor"
      d="M32.596 6H16.753A4.753 4.753 0 0012 10.753v28.41a4.752 4.752 0 004.753 4.752h15.843a4.752 4.752 0 004.753-4.753v-28.41A4.753 4.753 0 0032.596 6zm-7.922 35.539a1.584 1.584 0 110-3.168 1.584 1.584 0 010 3.168zm9.506-7.13a1.584 1.584 0 01-1.584 1.585H16.753a1.584 1.584 0 01-1.584-1.585V11.545a1.584 1.584 0 011.584-1.584h15.843a1.584 1.584 0 011.584 1.584v22.864z"
    ></path>
  </svg>
);

export default Phone;
